import { ajaxJson } from 'imports/ajax';
import { createTypes } from 'redux-create-types';
import { 
    map2CourseParticipation,
    map2CourseProgress,
    map2CourseObj,
    map2QuizOverview,
    map2ReportCardObj,
    map2ProjectOverview,
    map2Period,
} from 'imports/mapper';
import { courseActionCreators } from 'db/course/course.action';
import { quizActionsCreators } from '../../../../db/quiz/quiz.action';
import { projectActionsCreators } from '../../../../db/project/project.action';
import { courseActions } from '../../CourseActions'


const namespace = 'page-course-overview';

export const courseOverviewActions = createTypes([
    'toggleSpinner',
    'setError',
    'setExamData',
    'clearExamData',
    'setUserRate',
    'setFilterState',
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function getParticipationApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
            meta: {
                apiName: 'participation'
            }
        })
        return dispatch(hideSpinner('participation'));
    }
}

function getParticipationApiSuccess(res, courseId) {
    return dispatch => {
        const participationObj = map2CourseParticipation(res.data);
        dispatch(courseActionCreators.updateParticipationRate(courseId, participationObj.participationRate));
        return dispatch(hideSpinner('participation'));

    }
}

function getParticipationFromApi(programId, courseId, periodId) {
    return dispatch => {
        let params = {}
        if (periodId) {
            params = {
                period_uid: periodId,
            }
        }
        dispatch(showSpinner('participation'));
        return ajaxJson.get(`/activities/programs/${programId}/courses/${courseId}/participance`, {params})
        .then(
            res => dispatch(getParticipationApiSuccess(res, courseId)),
            err => dispatch(getParticipationApiFail(err)),
        )
    }
}

function getProgressApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
            meta: {
                apiName: 'progress'
            }
        })
        return dispatch(hideSpinner('progress'));
    }
}

function getProgressApiSuccess(res, courseId) {
    return dispatch => {
        const progressObj = map2CourseProgress(res.data);
        dispatch(courseActionCreators.updateProgress(
            courseId,
            progressObj.lockedUnitsCount,
            progressObj.seenUnitsCount,
            progressObj.totalUnitsCount,
        ));
        return dispatch(hideSpinner('progress'));            
    }
}

function getProgressFromApi(programId, courseId, periodId) {
    return dispatch => {
        let params = {}
        if (periodId) {
            params = {
                period_uid: periodId,
            }
        }
        dispatch(showSpinner('progress'));        
        return ajaxJson.get(`/activities/programs/${programId}/courses/${courseId}/progress`, {params})
        .then(
            res => dispatch(getProgressApiSuccess(res, courseId)),
            err => dispatch(getProgressApiFail(err)),
        )
    }
}

function getFinalStateApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('final-state'));
    }
}

function getFinalStateApiSuccess(res, programId, courseId) {
    return dispatch => {
        const reportStatusObj = map2ReportCardObj(res.data);
        const dispatch1 = dispatch(courseActionCreators.updateFinalScores(courseId, reportStatusObj.reportDate, reportStatusObj.totalScore));
        const dispatch2 = dispatch(courseActionCreators.cleanAllScoresFactor(courseId));
        const dispatches = reportStatusObj.factors.map((factor) => {
            return dispatch(courseActionCreators.addFinalScoresFactor(
                courseId,
                factor.key,
                factor.coefficient,
                factor.totalScore,
                factor.score,
            ));
        });
        return Promise.all([dispatch1, dispatch2, ...dispatches])
        .then(() => {
            return dispatch(hideSpinner('final-state'));
        });
    }
}

function getFinalStateFromApi(programId, courseId, periodId) {
    return dispatch => {
        let params = {}
        if (periodId) {
            params = {
                period_uid: periodId,
            }
        }
        dispatch(showSpinner('final-state'));        
        return ajaxJson.get(`/activities/programs/${programId}/courses/${courseId}/report_card`, {params})
        .then(
            res => dispatch(getFinalStateApiSuccess(res, programId, courseId)),
            err => dispatch(getFinalStateApiFail(err))
        )
    }
}

function getQuizzesApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
        }).then(() => {
            return dispatch(hideSpinner('quizzes'));
        });
    }
}

function getQuizzesApiSuccess(res, programId, courseId) {
    return dispatch => {
        res.data.forEach(quizOverview => {
            const quizOverviewObj = map2QuizOverview(quizOverview);
            dispatch(quizActionsCreators.saveOverview(quizOverviewObj, courseId));
        });
        return dispatch(hideSpinner('quizzes'));
    }
}

function getQuizzesFromApi(programId, courseId, periodId) {
    return dispatch => {
        let params = {}
        if (periodId) {
            params = {
                period_uid: periodId,
            }
        }
        dispatch(showSpinner('quizzes'));                
        return ajaxJson.get(`/activities/programs/${programId}/courses/${courseId}/quizzes`, {params})
        .then(
            res => dispatch(getQuizzesApiSuccess(res, programId, courseId)),
            err => dispatch(getQuizzesApiFail(err)),
        )
    }
}

function getProjectOverviewApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
        }).then(() => {
            return dispatch(hideSpinner('projects'));
        });
    }
}

function getProjectOverviewApiSuccess(res, programId, courseId) {
    return dispatch => {
        res.data['projects'].forEach(projectOverview => {
            const projectOverviewObj = map2ProjectOverview(projectOverview);
            dispatch(projectActionsCreators.saveCourseProjectOverview(courseId, projectOverviewObj));
        });
        dispatch(hideSpinner('projects'));
    }
}

function getProjectOverviewFromApi(programId, courseId, periodId) {
    return dispatch => {
        let params = {}
        if (periodId) {
            params = {
                period_uid: periodId,
            }
        }
        dispatch(showSpinner('projects'));
        return ajaxJson.get(`/activities/programs/${programId}/courses/${courseId}/projects`, {params})
        .then(
            res => dispatch(getProjectOverviewApiSuccess(res, programId, courseId)),
            err => dispatch(getProjectOverviewApiFail(err))
        )
    }
}

function getCourseOverviewApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('course'));
    }
}

function getCourseOverviewApiSuccess(res, programId, courseId) {
    return dispatch => {
        const courseObj = map2CourseObj(res.data);
        dispatch(courseActionCreators.save(courseObj));
        dispatch(quizActionsCreators.clearOverviews());
        dispatch(projectActionsCreators.cleanAllCourseProjectOverview(courseId));
        const dispatch1 = dispatch(getParticipationFromApi(programId, courseId));
        const dispatch2 = dispatch(getProgressFromApi(programId, courseId));
        const dispatch3 = dispatch(getFinalStateFromApi(programId, courseId));
        const dispatch4 = dispatch(getQuizzesFromApi(programId, courseId));
        const dispatch5 = dispatch(getProjectOverviewFromApi(programId, courseId));
        const dispatch6 = dispatch(getUserRateFromApi(programId, courseId));
        const dispatch7 = dispatch(getPeriodsFromApi(courseId));
        dispatch({
            type: courseActions.setBreadCrumb,
            payload: [
                {
                    title: courseObj.title,
                    order: 0,
                },
                {
                    title: 'روند پیشرفت درس',
                    order: 1,
                },
            ]
        });
        return Promise.all([
            dispatch1,
            dispatch2,
            dispatch3,
            dispatch4,
            dispatch5,
            dispatch6,
            dispatch7,
        ]).then(() => {
            return dispatch(hideSpinner('course'));
        });
    }
}

function getCourseOverviewFromApi(programId, courseId) {
    return dispatch => {
        dispatch(showSpinner('course'))
        return ajaxJson.get(`/courses/${courseId}`)
        .then(
            res => dispatch(getCourseOverviewApiSuccess(res, programId, courseId)),
            err => dispatch(getCourseOverviewApiFail(err)),
        )
    }
}

function getExamsApiSuccess(res, programId, courseId) {
    return dispatch => {
        const data = res.data[0];
        if (data) {
            dispatch({
                type: courseOverviewActions.setExamData,
                payload: {
                    id: data['uid'],
                    start: data['availability_start_date'],
                    end: data['availability_end_date'],
                    status: data['status'],
                    userExamStatus: data['user_exam_status']
                }
            });
        } else {
            dispatch({
                type: courseOverviewActions.clearExamData,
            });
        }
    }
}

function getExamsApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('exams'));
    }
}

function getExamsFromApi(programId, courseId) {
    return dispatch => {
        dispatch(showSpinner('exams'))
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/exams`)
        .then(
            res => dispatch(getExamsApiSuccess(res, programId, courseId)),
            err => dispatch(getExamsApiFail(err)),
        )
        .then(() => {
            dispatch(hideSpinner('exams'))
        })
    }
}

function getPeriodsApiSuccess(res, courseId) {
    return dispatch => {
        const periodsObj = res.data.map(p => {
            return map2Period(p)
        })
        dispatch(courseActionCreators.setPeriods(courseId, periodsObj));
    }
}

function getPeriodsApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
        })
    }
}

function getPeriodsFromApi(courseId) {
    return dispatch => {
        dispatch(showSpinner('periods'))
        return ajaxJson.get(`/courses/${courseId}/periods`)
        .then(
            res => dispatch(getPeriodsApiSuccess(res, courseId)),
            err => dispatch(getPeriodsApiFail(err)),
        )
        .then(() => {
            dispatch(hideSpinner('periods'))
        })
    }
}

function setFilterState(state) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setFilterState,
            payload: state,
        })       
    }
}

function getDataForCourse(programId, courseId) {
    return dispatch => {
        dispatch(quizActionsCreators.clearOverviews());
        dispatch(projectActionsCreators.cleanAllCourseProjectOverview(courseId));
        const dispatch1 = dispatch(getParticipationFromApi(programId, courseId));
        const dispatch2 = dispatch(getProgressFromApi(programId, courseId));
        const dispatch3 = dispatch(getFinalStateFromApi(programId, courseId));
        const dispatch4 = dispatch(getQuizzesFromApi(programId, courseId));
        const dispatch5 = dispatch(getProjectOverviewFromApi(programId, courseId));
        return Promise.all([
            dispatch1,
            dispatch2,
            dispatch3,
            dispatch4,
            dispatch5,
        ]).then(() => {
            
        });
    }
}

function getDataForPeriod(programId, courseId, periodId) {
    return dispatch => {
        dispatch(quizActionsCreators.clearOverviews());
        dispatch(projectActionsCreators.cleanAllCourseProjectOverview(courseId));
        const dispatch1 = dispatch(getParticipationFromApi(programId, courseId, periodId));
        const dispatch2 = dispatch(getProgressFromApi(programId, courseId, periodId));
        const dispatch3 = dispatch(getFinalStateFromApi(programId, courseId, periodId));
        const dispatch4 = dispatch(getQuizzesFromApi(programId, courseId, periodId));
        const dispatch5 = dispatch(getProjectOverviewFromApi(programId, courseId, periodId));
        const dispatch6 = dispatch(getUserRateFromApi(programId, courseId, periodId));
        return Promise.all([
            dispatch1,
            dispatch2,
            dispatch3,
            dispatch4,
            dispatch5,
            dispatch6,
        ]).then(() => {
            
        });
    }
}

function getUserRateApiSuccess(res) {
    return dispatch => {
        const items = res.data['leader_board_items'].map(item => {
            switch(item['leader_board']['board_type']) {
                case 'participance rate':
                    return {
                        title: 'میزان مشارکت',
                        rate: item['rating'] || 0,
                    }
                case 'exam':
                    return {
                        title: 'آزمون درس',
                        rate: item['rating'] || 0,
                    }
                case 'progress':
                    return {
                        title: 'مطالب دیده شده',
                        rate: item['rating'] || 0,
                    }
                case 'project':
                    return {
                        title: 'تکالیف / پروژه‌ها',
                        rate: item['rating'] || 0,
                    }
                case 'quiz':
                    return {
                        title: 'آزمون‌های پایان فصل',
                        rate: item['rating'] || 0,
                    }
                default:
                    return null
            }
        }).filter(i => (i !== null));
        dispatch({
            type: courseOverviewActions.setUserRate,
            payload: {
                totalUser: res.data['number_of_enrollments'],
                // overallRate: res.data['leader_board_items'].find(i => i['leader_board']['board_type'] === "overall")['rating'] || 0,
                items,
            }
        })
    }
}

function getUserRateApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseOverviewActions.setError,
            payload: err,
            meta: {
                apiName: 'rates'
            }
        })
    }
}

function getUserRateFromApi(programId, courseId, periodId) {
    return dispatch => {
        let params = {}
        if (periodId) {
            params = {
                period_uid: periodId,
            }
        }
        dispatch(showSpinner('rates'));
        return ajaxJson.get(`/activities/programs/${programId}/courses/${courseId}/leader_boards`, {params})
        .then(
            res => dispatch(getUserRateApiSuccess(res, programId, courseId)),
            err => dispatch(getUserRateApiFail(err))
        )
        .then(() => {
            dispatch(hideSpinner('rates'));
        })
    }
}

export {
    getCourseOverviewFromApi,
    getProjectOverviewFromApi,
    getExamsFromApi,
    getPeriodsFromApi,
    setFilterState,
    getDataForCourse,
    getDataForPeriod,
}
